import { Pipe, PipeTransform } from '@angular/core';
import { LoggerService } from '../services/logger/logger.service';
import { BASE_CONFIG } from '../util/base-settings';
import { APP_ROUTES, DATE_TIME_FORMAT, FILE_NAME } from '../util/constants';
import { DateFunctions } from '../util/date-functions';
@Pipe({
  name: 'dateAgo',
  pure: true
})
export class DateAgoPipe implements PipeTransform
{
  constructor(
    private logger : LoggerService,
    private dateFunctions: DateFunctions
  ) {

  }
  transform(pValue: Date, billStatus?: string): any
  {
    try {
      if(BASE_CONFIG.IS_DEBUG)  console.log('transform');
      
      if (pValue)
      {
        const today = this.dateFunctions.formatDate(new Date(), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2);
        const value = this.dateFunctions.formatDate(new Date(pValue), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2);
        const seconds = Math.floor( Math.abs((+new Date(today) - +new Date(value)) / 1000));
        if (billStatus && billStatus == APP_ROUTES.PAID) {
          return $localize`:@@dateAgo-paidOn:Paid on ${value}`;
        }
        if (today === value) {
          if (seconds < 29) // less than 30 seconds ago will show as 'Now'
          {
            return $localize`:@@dateAgo-dueToday:Due Today`;
            // return seconds + ' s';
          }
        }

        if (this.dateFunctions.getNextDate() === value) {
          return $localize`:@@dateAgo-dueTomorrow:Due Tomorrow`;
        }
  
        const intervals: { [key: string]: number; } = {
          'year': 31536000,
          'week': 604800,
          'day': 86400,
          // 'h': 3600,
          // 'm': 60,
          // 's': 1
        };
        let counter: number = 0;
  
        for (const i in intervals)
        {
          counter = Math.floor(seconds / intervals[i]);
  
          if (counter > 0)
          {
            let retValue = counter + ' ' + ( counter > 1 ? i+'s' : i + '') ; 
            return (+new Date(today) < +new Date(value) ?  $localize`:@@dateAgo-dueIn:Due in ${retValue}` : $localize`:@@dateAgo-ago:Due ${retValue} ago`);
          }
        }
      }
      return $localize`:@@dateAgo-dueToday:Due Today`;
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        FILE_NAME.DATE_AGO_PIPE,
        'error in date_ago_pipe transform',
        error.toString(),
        'date_ago_pipe transform'
      );
      this.logger.log(logRequest);
    }
  }

}